/**
 * Endpoint 8 — POST variant:fetchvariants (research/07 §8; REQ-API-7).
 * Lowercase path, Request constructor, fetch with no .catch — verbatim from
 * process_cart_page.js CARTPAGE_LoadVariants.
 */
import { appState } from "../state/app-state";

export async function CARTPAGE_LoadVariants(variants: any): Promise<any> {
  //Create Variant
  let cpc_variantData: any = null;
  let n = new Request(appState.baseCalculatorNewApiUrl + "variant:fetchvariants", {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ shop: appState.cpc_shopUrl, variants: variants }),
  });
  await fetch(n)
    .then((response) => response.json())
    .then(async (variants) => {
      cpc_variantData = variants;
    });

  return cpc_variantData;
}
